import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.5 19V5H12.5V19H3.5ZM2 4.5C2 3.94772 2.44772 3.5 3 3.5H13C13.5523 3.5 14 3.94772 14 4.5V19.5C14 20.0523 13.5523 20.5 13 20.5H3C2.44772 20.5 2 20.0523 2 19.5V4.5ZM10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.4041 8C21.5087 8 22.4041 7.10457 22.4041 6C22.4041 4.89543 21.5087 4 20.4041 4C19.2996 4 18.4041 4.89543 18.4041 6C18.4041 7.10457 19.2996 8 20.4041 8ZM20.9875 9.56126C21.0631 9.15401 20.7943 8.76256 20.387 8.68692C19.9798 8.61129 19.5883 8.88012 19.5127 9.28737L19.1991 10.9759L17.8242 10.6939L17.4929 8.32062C17.4356 7.91039 17.0566 7.62425 16.6464 7.68152C16.2362 7.73879 15.95 8.11777 16.0073 8.52801L16.363 11.0762C16.4362 11.6003 16.8315 12.0216 17.3499 12.1279L18.9252 12.4509L18.8832 12.6773C18.7561 13.3612 18.4631 14.0036 18.0299 14.5479L17.7512 14.8981C16.9411 15.9159 16.5001 17.1782 16.5001 18.4789V19.4243C16.5001 19.8385 16.8359 20.1743 17.2501 20.1743C17.6643 20.1743 18.0001 19.8385 18.0001 19.4243V18.4789C18.0001 17.5175 18.3261 16.5845 18.9248 15.8322L18.9276 15.8287L19.5129 17.5845C19.5554 17.712 19.6182 17.8317 19.6988 17.9392L21.1501 19.8743C21.3986 20.2057 21.8687 20.2728 22.2001 20.0243C22.5315 19.7758 22.5986 19.3057 22.3501 18.9743L20.9231 17.0717L19.9699 14.2119C20.1465 13.8094 20.2771 13.3865 20.3579 12.9511L20.9875 9.56126Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }